function tbInit(root) {
  var scope = root || document;
  scope.querySelectorAll('[data-tb-item]').forEach(function (item) {
    if (item.dataset.tbBound) return;
    item.dataset.tbBound = 'true';
    item.addEventListener('click', function () {
      var wasActive = item.classList.contains('is-active');
      item.parentElement.querySelectorAll('.is-active').forEach(function (el) {
        el.classList.remove('is-active');
      });
      if (!wasActive) item.classList.add('is-active');
    });
  });
}


document.addEventListener('DOMContentLoaded', function () {
  tbInit();
});

document.addEventListener('shopify:section:load', function (event) {
  tbInit(event.target);
});
